export default "__VITE_ASSET__XBYOthVm__"